export const keyWiseSettingsRouteMapping = {
	roles: 'roles',
	users: 'users',
	'chart of accounts': 'coa',
};

export const keyWiseConfigurationRouteMapping = {
	company: 'company',
	'branch code': 'branch-code',
	'category code': 'category-code',
	departments: 'department',
	'job grade': 'job-title',
	'cost center': 'cost-center',
	// earning: 'earning',
	// deduction: 'deduction',
	'leave type': 'leave-type',
	holidays: 'holidays',
	shift: 'shift',
};

export const keyWiseReportRouteMapping = {
	NAPSA: 'napsa',
	NHIMA: 'nhima',
	PAYE: 'paye',
	'payroll summary': 'payroll-summary',
	'p-18': 'p-18',
};

export const keyWisePayrollSettingsRouteMapping = {
	'company setup': 'company-setup',
	'pay period': 'pay-period',
	'statutory components': 'statutory-components',
	'pay group': 'pay-group',
	'earnings code': 'earning-code',
	'deduction code': 'deduction-code',
	'mid-month pay setup': 'mid-month-pay',
	'opening-balance': 'opening-balance',
	// 'payroll history': 'payroll-history',
};
export const keyWiseApprovalRouteMapping = {
	employee: 'employee',
};

export const employeeFieldsMapping = {
	firstName: 'First Name',
	lastName: 'Last Name',
	dob: 'Date Of Birth',
	country: 'Country',
	ssn: 'SSN',
	passportNo: 'Passport No',
	nationalRegistrationNo: 'National Registration No',
	joiningDate: 'Joining Date',
	recordStatus: 'Record Status',
	staffCode: 'Staff Code',
};

export const notificationConfigMapping: any = {
	EMPLOYEE: 'Employee',
	PAYROLL_RUN: 'Payroll Run',
	LOAN: 'Loan',
	TIME_ACTIVITIES: 'Time Activities',
};

export const bankMapping: any = {
	ABSA_BANK_ZAMBIA: {
		name: 'Absa Bank Zambia Ltd',
		logo: null,
	},
	ZANACO: {
		name: 'Zambia National Commercial Bank (Zanaco)',
		logo: null,
	},
	STANBIC_BANK: {
		name: 'Stanbic Bank Zambia Ltd',
		logo: '/assets/images/Stanbic-Bank-Logo.jpg',
	},
	INDO_ZAMBIA_BANK: {
		name: 'Indo‑Zambia Bank Ltd',
		logo: null,
	},
	STANDARD_CHARTERED: {
		name: 'Standard Chartered Bank Zambia Plc',
		logo: null,
	},
	ACCESS_BANK: {
		name: 'Access Bank Zambia Ltd',
		logo: null,
	},
	ECOBANK: {
		name: 'Ecobank Zambia Ltd',
		logo: null,
	},
	FIRST_ALLIANCE_BANK: {
		name: 'First Alliance Bank Zambia Ltd (FAB)',
		logo: null,
	},
	FIRST_CAPITAL_BANK: {
		name: 'First Capital Bank Zambia Ltd (FCB)',
		logo: '/assets/images/first-capital-bank.jpg',
	},
	FIRST_NATIONAL_BANK: {
		name: 'First National Bank Zambia Ltd (FNB)',
		logo: null,
	},
	UNITED_BANK_FOR_AFRICA: {
		name: 'United Bank for Africa Zambia Ltd (UBA)',
		logo: null,
	},
	ZAMBIA_INDUSTRIAL_COMMERCIAL_BANK: {
		name: 'Zambia Industrial Commercial Bank Plc (ZICB)',
		logo: null,
	},
	INVESTRUST_BANK: {
		name: 'Investrust Bank Plc',
		logo: null,
	},
};
